export default {"src":"/_next/static/media/simple-analytics.33d6122f.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};